export enum UserProfileScreens {
  Profile = 'profile',
  Contacts = 'contacts',
  Contact = 'contact',
  Projects = 'projects',
  Project = 'project',
  Accesses = 'accesses',
  Autos = 'autos',
  Auto = 'auto',
  Invite = 'invite',
  InviteCreation = 'invite-creation',
  Documents = 'documents'
}

export enum InviteCreationStage {
  Create = 'create',
  Confirmation = 'confirmation',
  CreationSucceed = 'creation-succeed',
  CreationFailed = 'creation-failed'
}
